import keyMirror from "keymirror";

const actions = {
  GET_RTO_REQUEST_LIST: null,
  GET_RTO_REQUEST_LIST_SUCCESS: null,
  GET_RTO_REQUEST_LIST_ERROR: null,
  GET_RTO_REQUEST_LIST_CLEAR: null,

  UPDATE_RTO_REQUEST_STATUS: null,
  UPDATE_RTO_REQUEST_STATUS_SUCCESS: null,
  UPDATE_RTO_REQUEST_STATUS_ERROR: null,
  UPDATE_RTO_REQUEST_STATUS_CLEAR: null,
};

export default keyMirror(actions);
